/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Input for configuring an environment variable for an MCP server.
 */
export type McpEnvironmentConfigInput = {
  /**
   * Custom display name for the variable in MCP headers
   */
  headerDisplayName?: string | undefined;
  /**
   * How the variable is provided: 'user', 'system', or 'none'
   */
  providedBy: string;
  /**
   * The name of the environment variable
   */
  variableName: string;
};

/** @internal */
export type McpEnvironmentConfigInput$Outbound = {
  header_display_name?: string | undefined;
  provided_by: string;
  variable_name: string;
};

/** @internal */
export const McpEnvironmentConfigInput$outboundSchema: z.ZodMiniType<
  McpEnvironmentConfigInput$Outbound,
  McpEnvironmentConfigInput
> = z.pipe(
  z.object({
    headerDisplayName: z.optional(z.string()),
    providedBy: z.string(),
    variableName: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      headerDisplayName: "header_display_name",
      providedBy: "provided_by",
      variableName: "variable_name",
    });
  }),
);

export function mcpEnvironmentConfigInputToJSON(
  mcpEnvironmentConfigInput: McpEnvironmentConfigInput,
): string {
  return JSON.stringify(
    McpEnvironmentConfigInput$outboundSchema.parse(mcpEnvironmentConfigInput),
  );
}
